// Glyphs for the settings rows.
//
// DELIBERATELY IDENTICAL IN SPEC TO NavIcons — 18px, 1.7 stroke, currentColor,
// no fill. An earlier pass drew these white on saturated per-row tiles, phone
// style. It scanned well in isolation and looked foreign next to everything
// else: this app is warm neutrals with a single sage accent, and ten carnival
// colours in the middle of it read as a different product.
//
// Colour comes from the row (see `.set-row-icon`), so hover and focus states
// apply automatically with no per-icon override — the same contract the
// sidebar icons follow.
const P = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

export const AuditorIcon = () => (
  <svg {...P}>
    <path d="M12 3.5 4.5 6.5v5c0 4.2 3 7.6 7.5 9 4.5-1.4 7.5-4.8 7.5-9v-5Z" />
    <path d="m9 11.8 2.1 2.1L15.2 9.8" />
  </svg>
);

export const ChecklistIcon = () => (
  <svg {...P}>
    <path d="M9 6h10M9 12h10M9 18h10" />
    <path d="m3.8 5.6 1.1 1.1 2-2.2M3.8 11.6l1.1 1.1 2-2.2M3.8 17.6l1.1 1.1 2-2.2" />
  </svg>
);

export const PortalIcon = () => (
  <svg {...P}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M3.5 12h17" />
    <path d="M12 3.5c2.2 2.4 3.4 5.4 3.4 8.5s-1.2 6.1-3.4 8.5c-2.2-2.4-3.4-5.4-3.4-8.5S9.8 5.9 12 3.5Z" />
  </svg>
);

export const ChatIcon = () => (
  <svg {...P}>
    <path d="M20.5 12c0 4-3.8 7.2-8.5 7.2a10 10 0 0 1-2.4-.3L4.5 20.5l1.3-3.6A6.8 6.8 0 0 1 3.5 12c0-4 3.8-7.2 8.5-7.2s8.5 3.2 8.5 7.2Z" />
  </svg>
);

export const AttendanceIcon = () => (
  <svg {...P}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.2V12l3.2 1.9" />
  </svg>
);

export const InvoiceIcon = () => (
  <svg {...P}>
    <path d="M6 3.5h12v17l-2.4-1.6-2.4 1.6-2.4-1.6-2.4 1.6-2.4-1.6Z" />
    <path d="M9.2 8.5h5.6M9.2 12.5h5.6" />
  </svg>
);

export const SecurityIcon = () => (
  <svg {...P}>
    <rect x="4.5" y="10.5" width="15" height="9.5" rx="2" />
    <path d="M8 10.5V7.8a4 4 0 0 1 8 0v2.7" />
  </svg>
);

export const OrganizationIcon = () => (
  <svg {...P}>
    <path d="M4 20.5V5.5A1.5 1.5 0 0 1 5.5 4h7A1.5 1.5 0 0 1 14 5.5v15" />
    <path d="M14 10h4.5A1.5 1.5 0 0 1 20 11.5v9" />
    <path d="M2.8 20.5h18.4M7 7.8h4M7 11.3h4M7 14.8h4" />
  </svg>
);

export const ContactIcon = () => (
  <svg {...P}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3.6 6.4 8.4 6.2 8.4-6.2" />
  </svg>
);

export const SubscriptionIcon = () => (
  <svg {...P}>
    <rect x="2.8" y="5" width="18.4" height="14" rx="2.2" />
    <path d="M2.8 9.6h18.4" />
    <path d="M6.4 14.6h3.4" />
  </svg>
);

export const ChevronIcon = () => (
  <svg {...P} width="15" height="15" strokeWidth="2">
    <path d="m9.5 5.5 6.5 6.5-6.5 6.5" />
  </svg>
);

export const BackIcon = () => (
  <svg {...P} strokeWidth="2">
    <path d="m14.5 5.5-6.5 6.5 6.5 6.5" />
  </svg>
);

export const SearchIcon = () => (
  <svg {...P} width="16" height="16">
    <circle cx="10.8" cy="10.8" r="6.3" />
    <path d="m15.5 15.5 4 4" />
  </svg>
);
